import { a as __rest, l as loadable$2, _ as __assign } from './loadable.esm-8884282c.js';
import React from 'react';

var ProxyVibrantIcon = function (_a) {
    var rest = __rest(_a, []);
    var Loaded = loadable$2(function () { return import('./VibrantIcon-4fdb3fd1.js'); });
    return React.createElement(Loaded, __assign({}, rest));
};

export { ProxyVibrantIcon as P };
